import { Button } from "@/components/ui/button";

type ErrorDisplayProps = {
  error: string;
  onReturnToSignup: () => void;
};

const ErrorDisplay = ({ error, onReturnToSignup }: ErrorDisplayProps): JSX.Element => {
  return (
    <div className="flex min-h-screen items-center justify-center px-4 py-8">
      <div className="w-full max-w-[30rem] rounded-2xl bg-white p-10 shadow-xl">
        <div className="flex flex-col gap-6">
          <div className="rounded-lg border border-red-200 bg-red-50 p-6 text-center">
            <p className="mb-3 text-xl font-semibold text-red-600">
              ⚠️ Error
            </p>
            <p className="text-red-700">
              {error}
            </p>
          </div>

          <p className="text-center text-sm text-gray-600">
            Serás redirigido al formulario de registro en breve, o puedes hacer clic abajo para volver ahora.
          </p>

          <Button
            onClick={onReturnToSignup}
            className="w-full bg-purple-600 text-white hover:bg-purple-700"
            size="lg"
          >
            Volver al Registro
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ErrorDisplay;
